/**
 * @fileoverview Hook to easily access the new AuthContext
 *
 * Provides easy access to authentication state and functions
 * throughout the application
 */

import { useContext } from 'react';
import { AuthContext } from '../components/Providers/AuthContext';

export const useAuthContext = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }

  return context;
};

// Convenience hooks for specific functionality
export const useUser = () => {
  const { user } = useAuthContext();
  return user;
};

export const useProfile = () => {
  const { userProfile, profileLoading } = useAuthContext();
  return { userProfile, profileLoading };
};

export const useAccountLinking = () => {
  const { linkWithEmail, accountType, canPromote } = useAuthContext();
  return { linkWithEmail, accountType, canPromote };
};

export const useProfileUpdate = () => {
  const { updateProfile } = useAuthContext();
  return { updateProfile };
};